import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LinksPage from "../pages/links/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/links",
    element: <LinksPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
